/* global Promise */

define('core/utils/media/upload',[
    'underscore',

    'exports',

    'core/api',
    'core/models/Media',
    'core/UniqueModel',
], function (
    _,

    exports,

    api,
    Media,
    UniqueModel
) {
    'use strict';

    // FormData is required to support uploadMedia
    exports.uploadSupported = Boolean(window.FormData);

    exports._extractFirstImageFile = function (files) {
        return _.find(files, function (file) {
            return file.type.match(/^image\//);
        });
    };

    exports._uploadViaApi = function (url, formData, options) {
        return Promise.resolve(api.call(url, {
            data: formData,
            // contentType: false allows the default header value
            // (multipart/form-data) to be used
            contentType: false,
            // processData: false prevents jQuery from throwing an
            // exception when it attempts to convert the properties
            // to strings
            processData: false,
            method: 'POST',
            // Workaround to listen to upload progress events
            xhr: function () {
                var xhr = new window.XMLHttpRequest();

                var onProgress = options && options.onProgress;
                if (onProgress) {
                    xhr.upload.addEventListener('progress', function (evt) {
                        // Update percentage remaining of upload
                        if (evt.total)
                            onProgress(100 * evt.loaded / evt.total);
                    });
                }

                return xhr;
            },
        }));
    };

    // API url for uploadMediaUrl
    // TODO: Get this url from the manifest
    exports.UPLOAD_URL = 'https://uploads.services.disqus.com/api/3.0/media/create.json';

    /**
     * Upload one image.
     * When given multiple images, will upload just the first.
     *
     * @param {FileList} files -
     *     The list of files; only the first image will be uploaded
     * @param {Object} [options] - Options
     * @param {function(number)} [options.onProgress] -
     *     Callback which will be passed the upload progress
     *     as a percentage (0-100)
     * @returns {Promise.<Media>}
     */
    exports.uploadMediaUrl = function (files, options) {
        var data = new window.FormData();
        var error;

        var imageFile = exports._extractFirstImageFile(files);
        if (!imageFile) {
            error = new Error('No image file to upload');
            error.code = 'invalid-content-type';
            return Promise.reject(error);
        }

        data.append('upload', imageFile);

        // Opt-in to permanent media urls
        data.append('permanent', 1);

        return exports._uploadViaApi(
            exports.UPLOAD_URL,
            data,
            options
        ).then(function (response) {
            var uploads = response.response;
            // Get the first upload
            var media = _.first(_.values(uploads));

            if (!media || !media.ok) {
                error = new Error('Upload failed');
                error.code = media && media['error-code'];
                throw error;
            }

            return new UniqueModel(Media, {
                mediaType: Media.MEDIA_TYPES.IMAGE_UPLOAD,
                url: media.url,
                thumbnailUrl: media.url,
            });
        }, function (jqXHR) {
            if (jqXHR.responseJSON && jqXHR.responseJSON.code === 4) {
                error = new Error('Upload failed');
                error.code = 'not-authenticated';
                throw error;
            }
            throw jqXHR;
        });
    };
});

